export const fuelList = [
  'FUELCARD',
  'FUELCARDKORT',
  'D_STATOIL',
  'D_SHELL',
  'D_ESSO',
  'D_YX',
  'L_MER',
  'L_KOPLE',
  'L_FORTUM',
]
